var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import _ from 'lodash';
import { useExecMethodApiQuery } from '../services/erp-method-api.service';
import { useGetQuery, useListQuery } from '../services/erp-resource-api.service';
var deriveModel = {
    'standard-list': useListQuery,
    'standard': useGetQuery,
    'exec': useExecMethodApiQuery
};
var useDerive = function (type, _a) {
    var options = _a.options, path = _a.path;
    var query = _.get(deriveModel, type);
    var response = query && query((__assign({}, options)));
    return __assign(__assign({}, response), { value: _.get(response === null || response === void 0 ? void 0 : response.data, path) });
};
export default useDerive;
